import React, { useState, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';

function getInitialTheme() {
  const stored = localStorage.getItem('rdh-theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('rdh-theme', theme);
  }, [theme]);

  const isDark = theme === 'dark';

  return (
    <Icon
      name={isDark ? 'sun' : 'moon'}
      link
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={() => setTheme(t => t === 'dark' ? 'light' : 'dark')}
      style={{ cursor: 'pointer', margin: 0 }}
    />
  );
}
